export default function openWithApp(osCode, scheme, customUrl, packageName, appStoreUrl, useIntent = true) {
  const intentUrl = `intent://${customUrl}#Intent;scheme=${scheme};package=${packageName};end`;
  const customScheme = `${scheme}://${customUrl}`;

  if (osCode === 'Android') {
    window.location = useIntent ? intentUrl : customScheme;
  } else if (osCode === 'iOS') {
    const clickedAt = +new Date;

    // 카카오톡내에서 실행된 경우 app 이 설치된 것으로 판단하고 appStoreUrl 띄우지 않음
    const uagent = navigator.userAgent.toLocaleLowerCase();
    if (uagent.search('kakaotalk') < 0) {
      setTimeout(function () {
        if (+new Date - clickedAt < 2000) {
          // PFPROJ-306: 톡으로 이동후 다시 appstore로 넘어가는 현상때문에 임시로 주석처리!
          // window.location = appStoreUrl;
        }
      }, 1500);
    }

    window.location = customScheme;
  } else {
    alert(`지원하지 않는 플랫폼입니다. (${osCode})`);
  }
}



// WEBPACK FOOTER //
// ./src/utils/openWithApp.js